export default __webpack_public_path__ + "static/5i-d12d151fcc941dfae6804c88737f5b9d.woff2";